import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem } from 'material-ui/List';
import Field from '../../../components/Field';
import FieldCheck from '../../../components/FieldCheck';
import { Panel } from '../../../components/Panel';
import noty from '../../../lib/noty';
import SubscriptionStatus from '../../../components/SubscriptionStatus';
import { checkAccountEditPermission } from '../../../components/Utilities';
import './style.scss';

export default class CurrentAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      touched: false,
      currentAccount: props.currentAccount
    };
  }

  handleChange = ({ name, value }) => {
    const path = name.split('.');
    this.setState({
      touched: true,
      currentAccount: this.state.currentAccount.setIn(path, value)
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { currentAccount } = this.state;
    this.setState({ fetching: true });
    currentAccount
      .patch()
      .then(() => {
        this.setState({ fetching: false, touched: false });
        noty.success('Account updated.');
      })
      .catch(err => {
        this.setState({ fetching: false });
        noty.errors(err);
      });
  };

  renderAccountEditorExpiredNotice() {
    return (
      <React.Fragment>
        <p style={{ fontWeight: 'bold', marginTop: '10px' }}>
          <span style={{ color: 'red' }}>Your free trial has ended. </span>
          Please add a credit card to continue using MapPlug.
        </p>
        <p>
          If you need anything, please use the chat below or email us at{' '}
          <a href="mailto:info@mapplug.com">info@mapplug.com</a>
        </p>
      </React.Fragment>
    );
  }

  renderNonEditorExpiredNotice() {
    const { ownerName } = this.props;
    return (
      <React.Fragment>
        <p style={{ fontWeight: 'bold', marginTop: '10px' }}>
          Your free trial has ended.
        </p>
        <p>
          To get access again, tell your account owner, {ownerName}, to set up
          billing to restore the system for you.
        </p>
        <p>
          If you need anything, please use the chat below or email us at{' '}
          <a href="mailto:info@mapplug.com">info@mapplug.com</a>
        </p>
      </React.Fragment>
    );
  }

  renderPlanList(plans) {
    const { currentAccount, fetching } = this.state;

    return plans.toList().map(plan => {
      let interval = 'a month';
      //REDTAG:TJH - update plan data with interval
      if('5f0891141963a0a5d72b6831' === plan._id.toString()){
        interval = 'annually';
      }
      return (
        <div key={plan._id}>
          <ListItem
            leftCheckbox={
              <FieldCheck
                name="plan_id"
                value={plan._id}
                onChange={this.handleChange}
                checked={currentAccount.plan_id === plan._id}
                disabled={fetching}
              />
            }
            primaryText={`${plan.name} plan`}
            secondaryText={
              plan.name === 'Enterprise'
                ? 'Enterprise pricing depends on your specific needs. Please contact us.'
                : `$${plan.price} ${interval}`
            }
          />
          {currentAccount.plan_id === plan._id && (
            <div className="plan-expand">
              <p>{plan.description}</p>
              <p>The {plan.name} plan includes:</p>
              <ul>
                {plan.features.map(feature => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      );
    });
  }

  render() {
    const { currentAccount, touched, fetching } = this.state;
    const { plans, currentUser, permissions, subscriptionStatus } = this.props;
    let { active } = subscriptionStatus;
    const accountEditPermission = checkAccountEditPermission({
      permissions,
      currentUser
    });

    return (
      <div id="CurrentAccount" className="margin-bottom-30">
        <Panel
          onSaveClick={this.handleSubmit}
          saveTitle="Save Account"
          touched={touched}
          fetching={fetching}
          touchedMessage="Are you sure you want to leave? Your account has unsaved changes."
        >
          <div>
            {!active ? (
              accountEditPermission ? (
                <React.Fragment>
                  {this.renderAccountEditorExpiredNotice()}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {this.renderNonEditorExpiredNotice()}
                </React.Fragment>
              )
            ) : null}
            <div className="row">
              <div className="col-xs-12">
                <Field
                  disabled={fetching}
                  label="Organization Name"
                  name="name"
                  value={currentAccount.name}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Field
                  disabled={fetching}
                  label="Organization Email"
                  name="billing_email"
                  value={currentAccount.billing_email}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <List>{this.renderPlanList(plans)}</List>
              </div>
            </div>
          </div>
        </Panel>
      </div>
    );
  }
}

CurrentAccount.propTypes = {
  plans: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  currentAccount: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  subscriptionStatus: PropTypes.instanceOf(SubscriptionStatus),
  ownerName: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/pages/Account/CurrentAccount/index.jsx